import { TrackingState } from 'gwi-tracker';
import isMobile from '../utils/mobile-checker';
import AbstractWatchableBrickConfig from './abstract-watchable-brick-config';

export default class PosterBrickConfig extends AbstractWatchableBrickConfig {
  constructor(params) {
    super(params);

    if (params.numberOfRatings !== undefined) {
      this.numberOfRatings = params.numberOfRatings;
    } else if (params.numberOfRatings === '0') {
      this.numberOfRatings = 0;
    } else {
      this.numberOfRatings = params.number_of_ratings;
    }

    if (params.trailerUrl !== undefined) {
      this.trailerUrl = params.trailerUrl;
    } else {
      this.trailerUrl = params.trailer_url;
    }
    this.posterUrl = params.posterUrl || params.poster_url;
    this.url = params.url;
    this.year = params.year;
    this.title = params.title;
    this.annotation = params.annotation;

    if (params.queueCount !== undefined) {
      this.queueCount = params.queueCount;
    } else {
      this.queueCount = params.queue_count;
    }

    if (params.inQueue !== undefined) {
      this.inQueue = params.inQueue;
    } else {
      this.inQueue = params.in_queue;
    }

    this.rating = params.rating;
    this.userRating = params.userRating || params.user_rating;
    this.isLoggedIn = params.isLoggedIn || params.is_logged_in || params.logged_in;
    this.externalLink = params.externalLink || params.external_link;
    this.isModalBrick = params.isModalBrick || params.is_modal_brick;

    this.hideUserActions = params.hideUserActions;

    // Tracking Information
    this.listId = params.listId || params.list_id;
    this.listItemId = params.listItemId || params.list_item_id;
    this.categoryId = params.categoryId || params.category_id;

    // Needed for ListItemClicks when in the widget.
    this.listItemContextType = params.listItemContextType || params.list_item_context_type;
    this.listItemContextId = params.listItemContextId || params.list_item_context_id;

    if (params.defaultTrackingOptions) {
      this.defaultTrackingOptions = params.defaultTrackingOptions;
    }

    if (params.isMobile !== undefined) {
      this.isMobile = params.isMobile;
    } else {
      this.isMobile = isMobile();
    }

    this.fireBrickImpression = params.fireBrickImpression;
    this.inWidget = params.inWidget;
    this.buildWithIframe = params.buildWithIframe;

    this.trackingState = this.trackingState || new TrackingState(
            this.watchableType,
            this.watchableId,
            this.getTrackingStateOptions(),
        );
  }

  getTrackingStateOptions() {
    return {
      defaultTrackingOptions: this.defaultTrackingOptions,

      brickId: this.brickId,
      campaign: this.campaign,
      inWidget: this.inWidget,
      medium: this.medium,
      mediumContext: this.mediumContext,
      categoryId: this.categoryId,

      listId: this.listId,
      listItemId: this.listItemId,
      listItemContextType: this.listItemContextType,
      listItemContextId: this.listItemContextId,
    };
  }

  merge(otherBrickData) {
    super.merge(otherBrickData);

    this.posterUrl = this.posterUrl || otherBrickData.posterUrl;
    this.url = this.url || otherBrickData.url;
    this.year = this.year || otherBrickData.year;
    this.title = this.title || otherBrickData.title;
    this.annotation = this.annotation || otherBrickData.annotation;
    this.queueCount = this.queueCount || otherBrickData.queueCount;
    this.numberOfRatings = this.numberOfRatings || otherBrickData.numberOfRatings;
    this.trailerUrl = this.trailerUrl || otherBrickData.trailerUrl;
    this.inQueue = this.inQueue || otherBrickData.inQueue;
    this.rating = this.rating || otherBrickData.rating;
    this.userRating = this.userRating || otherBrickData.userRating;
    this.isLoggedIn = this.isLoggedIn || otherBrickData.isLoggedIn;
    this.externalLink = this.externalLink || otherBrickData.externalLink;
    this.isModalBrick = this.isModalBrick || otherBrickData.isModalBrick;

    this.listId = this.listId || otherBrickData.listId;
    this.listItemId = this.listItemId || otherBrickData.listItemId;
    this.categoryId = this.categoryId || otherBrickData.categoryId;

    this.listItemContextType = this.listItemContextType || otherBrickData.listItemContextType;
    this.listItemContextId = this.listItemContextId || otherBrickData.listItemContextId;

    this.defaultTrackingOptions =
        this.defaultTrackingOptions ||
        otherBrickData.defaultTrackingOptions;

    this.isMobile = this.isMobile || otherBrickData.isMobile;

    if (this.inWidget === undefined) {
      this.inWidget = otherBrickData.inWidget;
    }

    if (this.buildWithIframe === undefined) {
      this.buildWithIframe = otherBrickData.buildWithIframe;
    }
  }

  toQueryParamObject() {
    const queryParams = super.toQueryParamObject();

    if (this.posterUrl) queryParams.posterUrl = this.posterUrl;
    if (this.year) queryParams.year = this.year;
    if (this.title) queryParams.title = this.title;
    if (this.queueCount !== undefined) queryParams.numberOfQueues = this.queueCount;
    if (this.url) queryParams.watchUrl = this.url;
    if (this.annotation !== undefined) queryParams.annotation = this.annotation;
    if (this.numberOfRatings !== undefined) queryParams.numberOfRatings = this.numberOfRatings;
    if (this.rating !== undefined) queryParams.rating = this.rating;
    if (this.trailerUrl !== undefined) queryParams.trailerUrl = this.trailerUrl;
    if (this.externalLink) queryParams.externalLink = this.externalLink;
    if (this.isModalBrick !== undefined) queryParams.isModalBrick = this.isModalBrick;

    if (this.listId) queryParams.listId = this.listId;
    if (this.listItemId) queryParams.listItemId = this.listItemId;
    if (this.categoryId) queryParams.categoryId = this.categoryId;

    if (this.listItemContextType) queryParams.listItemContextType = this.listItemContextType;
    if (this.listItemContextId) queryParams.listItemContextId = this.listItemContextId;

    if (this.hideUserActions) queryParams.hideUserActions = this.hideUserActions;
    if (this.isLoggedIn) queryParams.isLoggedIn = this.isLoggedIn;

    if (this.defaultTrackingOptions) {
      queryParams.defaultTrackingOptions = this.defaultTrackingOptions;
    }

    if (this.fireBrickImpression !== undefined) {
      queryParams.fireBrickImpression = this.fireBrickImpression;
    }

    if (this.inWidget !== undefined) {
      queryParams.inWidget = this.inWidget;
    }

    if (this.id) {
      queryParams.brickId = this.id;
    }

    queryParams.isMobile = this.isMobile;

    return queryParams;
  }
}



// WEBPACK FOOTER //
// ./src/models/poster-brick-config.js